var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome-banner"},[_c('div',{staticClass:"banner-left"},[_c('h2',{staticClass:"banner-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"banner-sub"},[_vm._v(_vm._s(_vm.subtitle))])]),_vm._v(" "),_c('div',{staticClass:"banner-right"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }